import { useState } from "react";
import { AGGREGATION_LEVELS } from "../../constants/kpiConstants";
import { DateTimePicker, NumberInput, Select } from "../form_components/Input";
import Button from "../ui/Button";
import { MapPin } from "lucide-react";

/**
 * Reusable filter form for KPI pages
 */
export default function KPIFilterForm({
  filters,
  onInputChange,
  onSubmit,
  loading,
  error,
  showInterval = true,
  showEndDate = false,
  showAggregation = true,
  systems,
}) {
const [errors, setErrors] = useState({});
  
  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-4">
      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
          {error}
        </div>
      )}

      <Select
        label="Select Intersection"
        value={
          filters.systemId != null &&
          filters.systemId !== "" &&
          filters.streetId != null &&
          filters.streetId !== ""
            ? `${filters.systemId},${filters.streetId}`
            : ""
        }
        onChange={(value) => {
          const [systemId, streetId] = value.split(",").map(Number);
          onInputChange("systemId", systemId);
          onInputChange("streetId", streetId);
        }}
        options={systems}
        optionValue="composite_key"
        renderOption={(system) => `System ${system.system_id}, ${system.street_name}`}
        placeholder="Select a system"
        error={errors.systemId}
        required
        icon={MapPin}
        disabled={loading}
      />

      {showInterval && (
        <NumberInput
          label="Interval (seconds)"
          value={filters.interval}
          onChange={(value) => onInputChange("interval", value)}
          placeholder="Enter Interval"
          required
          min="1"
        />
      )}

      <div className="border-t pt-4">
        <label className="text-sm font-medium text-gray-700 mb-2 block">
          Start Date & Time
        </label>
        <DateTimePicker
          date={filters.startDate}
          time={filters.startTime}
          onDateChange={(value) => onInputChange("startDate", value)}
          onTimeChange={(value) => onInputChange("startTime", value)}
        />
      </div>

      {showEndDate && (
        <div className="border-t pt-4">
          <label className="text-sm font-medium text-gray-700 mb-2 block">
            End Date & Time (Optional)
          </label>
          <DateTimePicker
            date={filters.endDate}
            time={filters.endTime}
            onDateChange={(value) => onInputChange("endDate", value)}
            onTimeChange={(value) => onInputChange("endTime", value)}
          />
        </div>
      )}

      {showAggregation && (
        <div className="flex flex-col gap-2">
          <label className="text-sm font-medium text-gray-700">
            Aggregation Level
          </label>
          <select
            value={filters.aggregationLevel}
            onChange={(e) => onInputChange("aggregationLevel", e.target.value)}
            className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          >
            {AGGREGATION_LEVELS.map((level) => (
              <option key={level} value={level}>
                {level === "15mins"
                  ? "15 Minutes"
                  : level === "hourly"
                    ? "Hourly"
                    : "Daily"}
              </option>
            ))}
          </select>
        </div>
      )}

      <Button type="submit" disabled={loading} className="w-full">
        {loading ? "Loading..." : "Apply Filters"}
      </Button>
    </form>
  );
}
